import * as React from "react";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import ButtonExport from "components/Buttons/ButtonExport";
import IconExcel from "components/Icons/IconExcel";

interface IProps {
    csvData: any;
    fileName: string;
}

export function exportToXLSX(csvData: any, fileName: string) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
}

export const ExportToExcel: React.FC<IProps> = ({ csvData, fileName }) => {
    return (
        <ButtonExport
            startIcon={<IconExcel fixedWidth />}
            onClick={(e) => exportToXLSX(csvData, fileName)}
        />
    );
};
